<template>
  <div class="xscontainer jsjiesh" style="width: 100%;">
      <div class="spzskkkd">
        <div class="splist" v-for="(item,index) in shipinzhishis.fenleis">
          <div class="shipk" @click="gotoshipinList(item)">
            <p class="btt">{{item.dictname}}</p>
            <div>
              <img class="playcs" src="@/assets/xxkc/2.png">
            </div>
          </div>
          <div class="rlj">
            <div class="ljitem wzslh_wrap" v-for="(item2,index2) in shipinzhishis[item.dictname]" v-if="index2 < 3" @click="gotoshipinbofang(item2)">{{item2.biaoti}}</div>
          </div>
          <div class="rlj">
            <div class="gd" @click="gotoshipinList(item)">更多>></div>
            <div class="ljitem"></div>
            <div class="ljitem"></div>
          </div>
        </div>
<!--        <fenye style="justify-content: center"></fenye>-->
      </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shipinzhishis:{

      },
      fwcishu:0
    };
  },
  mounted() {
    this.queryFenleis();
  },
  created() {
    this.tongji('视频知识');
  },
  methods:{
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    gotoshipinbofang(item){
      this.$router.push({path:'/spbf',query:{currobj:item}});
    },
    gotoshipinList(item){
      this.$router.push({path:'/zlkc',query:{fenlei:item.dictname,dictms:item.dictms}});
    },
    queryFenleis(){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/shipin/tShipin/queryByFenlei?_t='+new Date().getTime()+'&column=id&order=asc&pageNo='+0+'&pageSize='+6)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.shipinzhishis  = response.data.result;
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
  }
};
</script>

<style scoped>
.spzskkkd{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4rem;
}

.splist {
  display: flex;
  gap: 3rem;
}
.splist:hover {
  cursor: pointer;
}

.shipk {
  width: 26rem;
  min-height: 6rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border:1px solid #0f7cf2;
  background-image:  url('../../assets/xxkc/3.png');
  background-position: center;
  background-repeat: no-repeat;
}

.btt {
  font-weight: bold;
  font-size: 18px;
}

.playcs {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  box-shadow: 0px 0px 1px 0px #55a2da;
}

.rlj {
  width: 18rem;
  min-height: 6rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-around;
  gap: 0.3rem;
}

.ljitem {
  height: 1.7rem;
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 显示省略号 */
  width: 100%;         /* 设置固定宽度 */
}

.gd {
  color: #167deb;
}
.gd:hover{
  cursor: pointer;
  color: #0f5aab;
}
.ljitem:hover{
  cursor: pointer;
  color: #167deb;
}
.shipk:hover{
  cursor: pointer;
}
</style>
